import { ActivityInformation, Edge } from '../../../typings'
import { userType } from '../constants'
import { groupApi } from './groupApi'

export interface GroupActivitiesResponse {
  totalCount: number
  edges: Edge<ActivityInformation>[]
}

interface GroupActivitiesPayload {
  groupId: string
  startCursor: number
  totalItems?: number
}

export const activitiesApiSlice = groupApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivities: builder.query<
      GroupActivitiesResponse,
      GroupActivitiesPayload
    >({
      query: ({ groupId, startCursor }) => ({
        url: `/${groupId}/activities?startCursor=${startCursor}`,
      }),
      async onQueryStarted({ groupId }, { dispatch, queryFulfilled }) {
        try {
          const result = await queryFulfilled

          dispatch(
            groupApi.util.updateQueryData(
              'getGroupDetail',
              groupId,
              (group) => {
                group.customer.moneyPools.moneyPool.activities.edges.push(
                  ...result.data.edges,
                )
              },
            ),
          )

          dispatch(
            groupApi.util.updateQueryData(
              'getCurrentUserGroups',
              { userType: userType.CREATOR },
              (groups) => {
                const groupToUpdate = groups.edges.find(
                  (item) => item.node.id === groupId,
                )
                groupToUpdate.node.activities.edges.push(...result.data.edges)
              },
            ),
          )
        } catch (error) {
          // We don't want to do anything with the info in error cases.
        }
      },
    }),
  }),
})

export const { useLazyGetActivitiesQuery } = activitiesApiSlice
